import { render, staticRenderFns } from "./QR_Reader.vue?vue&type=template&id=424a7986&scoped=true"
import script from "./QR_Reader.vue?vue&type=script&lang=js"
export * from "./QR_Reader.vue?vue&type=script&lang=js"
import style0 from "./QR_Reader.vue?vue&type=style&index=0&id=424a7986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424a7986",
  null
  
)

export default component.exports